<template>
  <main>
    <md-steppers md-active-step="apply" md-alternative md-linear>
      <md-step id="email" md-label="メール認証"></md-step>
      <md-step id="apply" md-label="本契約の手続き"></md-step>
      <md-step id="start" md-label="ご利用開始"></md-step>
    </md-steppers>

    <div class="md-layout md-alignment-center">
      <md-card class="md-layout-item md-size-90 md-small-size-100">
        <flash-message v-if="getValidationResponseMessage('code') &&
                             getValidationResponseMessage('code').indexOf('有効ではありません') !== -1"
                       :errors="['有効期限が切れているか、すでに申し込み済みの可能性があります。<br>'
                       + 'お手数ですが、再度「 <a href=\'/contract/email\'>メール認証</a> 」より登録を行ってください。']"></flash-message>
        <flash-message v-else-if="getValidationResponseMessage('code')"
                       :errors="[getValidationResponseMessage('code')]"></flash-message>
        <flash-message v-else-if="errorMessages.length" :errors="errorMessages"></flash-message>

        <md-card-header>
          <div class="md-title">本契約の手続き</div>
        </md-card-header>

        <div class="md-layout">
          <div class="md-layout-item md-size-10 md-small-size-100"></div>
          <div class="md-layout-item md-size-80 md-small-size-100">
            <md-card-content>
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <p>ご利用上の注意を必ずご確認の上、本契約へお進みください。</p>
                  <p class="text-error">
                    ※本契約には登記情報提供サービスのIDが必要です。<br>
                    ※本契約の手続きは、平日8:30〜22:55・土日祝日8:30〜17:55の受付となります。
                  </p>
                </div>
              </div>
            </md-card-content>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-size-15 md-small-size-100"></div>
          <div class="md-layout-item md-size-70 md-small-size-100">
            <md-card-content class="md-description">
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-large-size-20 md-layout"></div>
                <div class="md-layout-item md-large-size-60 md-layout md-alignment-center-center">
                  <span>必須</span>
                  <md-button @click="toPayment" class="md-raised">
                    <span>ご利用上の注意</span>
                    <md-icon>arrow_right</md-icon>
                  </md-button>
                </div>
                <div class="md-layout-item md-large-size-20 md-layout"></div>
              </div>
            </md-card-content>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-size-15 md-small-size-100"></div>
          <div class="md-layout-item md-size-70 md-small-size-100">
            <md-card-actions>
              <div class="md-layout md-alignment-center">
                <!--キャンペーン用-->
                <md-button class="md-primary md-raised md-alignment-center-center" @click="showPaymentCaution = true"
                           v-if="onBusinessTime && !showedPayment" :disabled="sending || !verifyEmail">
                  <span>ご利用上の注意を確認して<br>本契約へ進む</span>
                  <md-icon>arrow_right</md-icon>
                </md-button>
                <md-button @click.native="moveToContractApply()"
                           class="md-primary md-raised md-alignment-center-center" tag="md-button"
                           v-else-if="onBusinessTime && showedPayment" :disabled="sending || !verifyEmail">
                  <span>ご利用上の注意を確認して<br>本契約へ進む</span>
                  <md-icon>arrow_right</md-icon>
                </md-button>

                <!--Tサービス停止時用-->
                <md-button class="md-primary md-raised md-alignment-center-center" disabled="disabled" v-else>
                  <span>ご利用上の注意を確認して<br>本契約へ進む</span>
                  <md-icon>arrow_right</md-icon>
                </md-button>
              </div>
            </md-card-actions>
          </div>
        </div>

        <!--必ず利用規約をお読みください-->
        <md-dialog :md-active.sync="showPaymentCaution">
          <md-dialog-title>必ずご利用上の注意をお読みください</md-dialog-title>
          <md-dialog-actions>
            <md-button class="md-primary" @click="showPaymentCaution = false">閉じる</md-button>
          </md-dialog-actions>
        </md-dialog>
      </md-card>
    </div>
  </main>
</template>

<script>
import CommonMixin          from '../../mixins/commonMixin';
import FlashMessage         from '../../components/FlashMessage';
import Common               from "../../modules/common";
import {apiClient, apiList} from "../../modules/apiClient";
import {mapActions}         from "vuex";

export default {
  name      : "ContractVerify",
  components: {FlashMessage},
  mixins    : [CommonMixin],
  data      : () => ({
    showPaymentCaution: false,
    showedPayment     : false,
    verifyEmail       : false,
  }),
  mounted   : function () {
    this.saveFormData(null);
    this.getVerifyEmail();
  },
  methods   : {
    ...mapActions('contractFormError', [
      'saveValidateResponse',
      'saveErrorMessages',
    ]),
    ...mapActions('contractForm', [
      'saveFormData',
    ]),
    getVerifyEmail() {
      this.sending = true;
      localStorage.removeItem(Common.localStorageKeys.contract.email)
      this.saveFormData(null);
      apiClient
          .get(apiList.verify_email, {
            params: {
              code: this.$route.query.vid,
            }
          })
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }
            this.saveValidateResponse([]);
            this.saveErrorMessages([]);
            localStorage.setItem(Common.localStorageKeys.contract.email, response.data.email)
            this.verifyEmail = true
            Common.onBusinessTime().then(value => {
              this.onBusinessTime = value
              this.sending        = false
            });
          })
          .catch(error => {
            this.errorMessages = [error.message];
            this.sending       = false;
          })
          .finally(() => {
          });
    },
    toPayment() {
      window.open('/payment', '_blank');
      this.showedPayment = true;
    },
    moveToContractApply() {
      localStorage.setItem(Common.localStorageKeys.contract.verify, 'ContractVerify');
      this.$router.replace({name: 'ContractApply'})
    },
  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/components";

.md-steppers {
  height: 104px;
}

.md-stepper {
  padding: 0;
}

.md-card {
  margin-top: 20px;
  margin-bottom: 30px;
}

.md-description {
  font-size: 1.1rem;

  .md-layout-item:nth-child(2) {
    color: #fff;
    font-size: 90%;
    background-color: #ff5252;
    height: 70px;
  }
}

.md-card-actions {
  margin-top: 30px;

  .md-button {
    height: 52px;
  }
}

.text-error {
  color: #ff5252;
}

.mb-40 {
  margin-bottom: 40px;
}

.md-pt-0 {
  padding-top: 0px;
}

.md-pb-0 {
  padding-bottom: 0px;
}
</style>
